<div style="margin: 3% 0%;background-color: white;overflow: hidden;">
    <div style="text-align: center;">
        <h2 style="font-family: Montserrat;">All the Features you need</h2>
    </div>
    <div class="features_info row" style="margin: 4%;">
        <div *ngFor="let features of features;let i = index" class="features_data col-md-4">
            <div class="features_image">                
                <img [src]="features.image" alt="Features" style="width:50px;height: 50px;">
            </div>
            <div class="features_header">
                <h3 style="font-family: Montserrat;font-weight:bold;">{{features.header}}</h3>
            </div>
            <div class="features_description">{{features.description}}</div>
            <button class="show_more_button" (click)="navigateToFeature(i)">Show More</button>
        </div>
    </div>
</div>